// Б.3: Рипер active — «Сбрось своего юнита с поля, чтобы нанести его Атаку
// в лицо вражескому Герою».
//
// Цель: любой свой юнит на поле (включая Скрытных, спящих в Initiation,
// недавно выставленных).
//
// Эффект:
//   1. Зафиксировать current.atk выбранного юнита (со всеми баффами).
//   2. Юнит уходит в обычную смерть. Посмертие активируется (Эксп. батарея,
//      Второе сердце и пр.) через onUnitDied → applyModDeathTriggers.
//   3. Вражескому Герою наносится урон, равный зафиксированной атаке. Через
//      applyHeroDamage — НЕ пробивающий, броня поглощает. Учитывается
//      Парашют, Иммунитет, Секретарь.
//   4. Активка ПРОБИВАЕТ Авангард (canAttackHero не проверяется): бьёт Героя
//      даже если у врага есть юниты. Правило Авангарда касается атак юнитов
//      и Героя — это активка, отдельный эффект.
//   5. checkMatchOver для возможной победы — вызывается вызывающим кодом.

import { applyHeroDamage } from '../../hero-damage.js';
import { onUnitDied } from '../deus/index.js';

export const HERO_ID = 'syn_uein';

// Свои живые юниты — все, без фильтров (Стелс/спящий допустимы).
export function getRiperActiveTargets(state, playerIdx) {
  return state.players[playerIdx].unitsOnField();
}

export function riperActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  if (getRiperActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

// Возвращает {ok, dmg, killed?} либо {ok:false, reason}.
export function riperActive(state, playerIdx, targetCard) {
  if (!riperActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  if (!targetCard || targetCard.type !== 'unit' || !targetCard.isAlive()) {
    return { ok: false, reason: 'invalid_target' };
  }
  const me = state.players[playerIdx];
  if (targetCard.ownerId !== me.id) {
    return { ok: false, reason: 'not_ally' };
  }
  if (!me.unitsOnField().includes(targetCard)) {
    return { ok: false, reason: 'not_on_field' };
  }
  const enemy = state.players[1 - playerIdx];
  // 1) Зафиксировать current.atk.
  const dmg = targetCard.current.atk;
  state.log.add(
    `✨ Рипер [${me.name}] [active]: жертвует ${targetCard.name_ru} (atk ${dmg}) → удар по Герою [${enemy.name}]`
  );
  // 2) Юнит уходит в обычную смерть. Посмертие через onUnitDied.
  targetCard.alive = false;
  me.removeFromField(targetCard);
  state.log.add(`✗ ${targetCard.name_ru} [${me.name}] погибает (Рипер active)`);
  onUnitDied(state, {
    ownerIdx: playerIdx, card: targetCard,
    killer: null, killerIdx: null, killerWasCounter: false
  });
  // 3) Урон Герою врага — не пробивающий, через applyHeroDamage.
  // Активка пробивает Авангард, но броня и Парашют работают.
  const r = applyHeroDamage(state, 1 - playerIdx, dmg, { pierce: false });
  if (!r.immune && !r.parachute) {
    state.log.add(
      `⚔ Рипер [active] → ${enemy.hero.name_ru} [${enemy.name}]: ${dmg} урона ` +
      `(HP ${enemy.hero.current.hp + (r.hpLost || 0)}→${enemy.hero.current.hp}, ` +
      `броня ${enemy.hero.current.armor + (r.armorAbsorbed || 0)}→${enemy.hero.current.armor})`
    );
  }
  me.heroActiveUsed = true;
  return { ok: true, dmg, killed: enemy.hero.current.hp <= 0 };
}
